"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MainMenuLink;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRouterDom = require("react-router-dom");
var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    active: {
      backgroundColor: "".concat(theme.palette.primary.main, " !important")
    },
    icon: {
      color: function color(_ref) {
        var active = _ref.active;
        return [active ? theme.palette.primary.contrastText : 'rgba(255,255,255,0.54)'];
      },
      marginLeft: -6,
      marginRight: -4,
      minWidth: theme.spacing(4)
    },
    iconElement: {
      fontSize: 20
    },
    root: {
      '&:focus': {
        '& $icon': {
          color: theme.palette.primary.contrastText
        },
        backgroundColor: (0, _styles.emphasize)('rgba(0, 119, 200, 0.7)', 0.08)
      },
      '&:hover': {
        '& $icon': {
          color: theme.palette.primary.contrastText
        },
        backgroundColor: (0, _styles.emphasize)('rgba(255, 255, 255, 0.12)', 0.08)
      },
      borderRadius: 4,
      color: theme.palette.primary.contrastText,
      fontWeight: 'normal',
      marginLeft: 8,
      marginRight: 8,
      marginTop: 4,
      minHeight: 40,
      outline: 'none',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    },
    tooltip: {
      backgroundColor: '#212121',
      boxShadow: theme.shadows[1],
      fontSize: 13,
      left: 8,
      padding: 7
    },
    tooltipArrow: {
      color: '#212121'
    }
  };
});
function MainMenuLink(_ref2) {
  var children = _ref2.children,
    collapsed = _ref2.collapsed,
    closeMenu = _ref2.closeMenu,
    _ref2$BadgeProps = _ref2.BadgeProps,
    BadgeProps = _ref2$BadgeProps === void 0 ? {} : _ref2$BadgeProps,
    href = _ref2.href,
    icon = _ref2.icon,
    id = _ref2.id,
    isMatch = _ref2.isMatch,
    target = _ref2.target,
    textKey = _ref2.textKey,
    to = _ref2.to;
  var classes = useStyles({
    active: isMatch
  });
  var IconElement = icon;
  return /*#__PURE__*/_react.default.createElement("li", {
    id: id
  }, /*#__PURE__*/_react.default.createElement(_material.Tooltip, {
    arrow: true,
    classes: {
      arrow: classes.tooltipArrow,
      tooltip: classes.tooltip
    },
    placement: "right",
    title: collapsed && textKey ? /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
      id: textKey
    }) : ''
  }, /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
    className: (0, _classnames.default)(classes.root, isMatch && classes.active),
    component: href ? 'a' : _reactRouterDom.Link,
    href: href,
    id: "".concat(id, "Link"),
    onClick: closeMenu,
    tabIndex: 0,
    target: target,
    to: to
  }, /*#__PURE__*/_react.default.createElement(_material.ListItemIcon, {
    className: classes.icon,
    id: "".concat(id, "LinkIcon")
  }, /*#__PURE__*/_react.default.createElement(_material.Badge, (0, _extends2.default)({
    color: "error",
    id: "".concat(id, "LinkIconBadge"),
    invisible: true,
    showZero: true,
    variant: "dot"
  }, BadgeProps), /*#__PURE__*/_react.default.createElement(IconElement, {
    className: classes.iconElement
  }))), !collapsed && (children || /*#__PURE__*/_react.default.createElement(_material.ListItemText, {
    id: "".concat(id, "LinkText"),
    primary: textKey && /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
      id: textKey
    })
  })))));
}